import axios from 'axios';
import { Capacitor } from '@capacitor/core';

// En el navegador (o la PWA instalada), la ruta relativa "/api" ya resuelve contra el mismo
// dominio que sirvió la app — así es en Hostinger, donde nginx sirve frontend y backend desde el
// mismo dominio. Pero una app nativa de Capacitor carga sus archivos desde un origen local
// (https://localhost) que no tiene backend propio, así que ahí necesita la URL absoluta de
// producción. Y en un despliegue con frontend y backend en dominios distintos (ej. Netlify +
// Render), REACT_APP_API_URL (fijada en build time) apunta directo al backend.
const baseURL = Capacitor.isNativePlatform()
  ? 'https://gestionadrantaleh.com/api'
  : (process.env.REACT_APP_API_URL || '/api');

// 60s: en Hostinger/local 15s sobraba, pero un backend gratuito en Render "duerme" por
// inactividad y puede tardar 50+ segundos en despertar con la primera petición — con 15s esa
// petición se cancelaba antes de que Render respondiera, y el usuario veía un error genérico.
const api = axios.create({
  baseURL,
  timeout: 60000,
});

// Agregar token a cada request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Manejar errores globalmente
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
